var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "name-array" }, [
    _c("div", { staticClass: "title" }, [
      _vm._v("\n        " + _vm._s(_vm.name) + "\n    ")
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "array" },
      _vm._l(_vm.line_data, function(item, idx) {
        return _c(
          "div",
          {
            key: idx,
            staticClass: "grid",
            attrs: { title: _vm.name + ":" + (idx + 1) }
          },
          [_vm._v("\n            " + _vm._s(item) + "\n        ")]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }